export enum WALLET_TYPE {
  ICON = "icon",
  LEDGER = "ledger",
  NONE = "none",
}
